export default {
    name: 'AdsSelector',
    props: {
        path: {
            type: String,
            required: true,
        },
        db: {
            type: String,
            required: true,
        },
        domain: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            viewMode: null,
            options: [
                {label: this.$t('lang.report.ads.data_all'), value: ''},
                {label: this.$t('lang.report.ads.data_unique_links'), value: '&view=links'},
            ],
        }
    },
    methods: {
        onChangeMode() {
            window.open(sprintf("%s?base=%s&domain=%s%s", this.path, this.db, this.domain, this.viewMode), '_self');
        },
    },
}
